import React from 'react';
import ReactDOM from 'react-dom';
import Environment from '../environment/environment.js';
import TagPlaceholder from '../common/tag-placeholder.js';

export const Tools = {};

Tools.events = {
  lsi: 'UU5_Common_LsiMixin_lsiEvent',
  highlight: 'UU5_Bricks_TextCorrector_highlightEvent',
  dateTime: 'UU5_Bricks_DateTime_event',
  number: 'UU5_Bricks_Number_event'
};

Tools.screenSize = {
  xs: 0,
  sm: 768,
  md: 992,
  lg: 1200
};

Tools.getPage = () => {
  return Environment.page;
};

Tools.checkTag = function (tag, hideError) {
  let cTag = tag;
  if (typeof cTag === 'string') {
    let tagArray = cTag.split('.');
    let isSimpleString = tagArray.length === 1;
    let calculatedTag = window;
    while (calculatedTag && tagArray.length > 0) {
      calculatedTag = calculatedTag[tagArray.shift()];
    }
    cTag = calculatedTag ? calculatedTag : isSimpleString ? cTag : null;
  }
  if (typeof cTag !== 'function' && typeof cTag !== 'string' && !hideError) {
    Tools.error(
      'Unknown tag ' + tag + ' - element was not found.', {
        notFoundObject: cTag,
        notFoundObjectType: typeof cTag
      }
    );
    cTag = null;
    //cTag = UU5.Bricks.NotFoundTag;
  }

  return cTag;
};

Tools.findTag = (tag, props, content) => {
  let newTag = tag;
  if (typeof tag === 'object' && tag.tag) {
    newTag = tag.tag;
    props = tag.props;
  }

  let fTag = Tools.checkTag(newTag, true);

  return fTag ? React.createElement(fTag, props, content) :
    <TagPlaceholder tagName={newTag} props={props} content={content} />;
};

Tools.buildAttributes = function (attrsString) {

  let attrs = {};
  let attrsRegEx = /([-\w]+)(?:\s*=\s*(?:(?:"(<uu5json\/>(?:\\.|[^"])*?)")|(?:'(<uu5json\/>(?:\\.|[^'])*?)')|(?:"(<uu5string\/>(?:\\.|[^"])*?)")|(?:'(<uu5string\/>(?:\\.|[^'])*?)')|(?:"(<uu5data\/>(?:\\.|[^"])*?)")|(?:'(<uu5data\/>(?:\\.|[^'])*?)')|(?:"((?:\\.|[^"])*?)")|(?:'((?:\\.|[^'])*?)')|([^\s]+)))?/g;
  //group1 = name (Attribute name)
  //group2 = value (uu5JSON "...")
  //group3 = value (uu5JSON '...')
  //group4 = value (uu5String "...")
  //group5 = value (uu5String '...')
  //group6 = value (uu5Data "...")
  //group7 = value (uu5Data '...')
  //group8 = value (string "...")
  //group9 = value (string '...')
  //group10 = value (no string ... null, true, false, number)
  let matchAttrs = attrsRegEx.exec(attrsString);

  while (matchAttrs) {
    let name = matchAttrs[1];
    let value = true;
    let matchValue = matchAttrs[2] || matchAttrs[3] || matchAttrs[4] || matchAttrs[5] || matchAttrs[6] || matchAttrs[7] || matchAttrs[8] || matchAttrs[9] || matchAttrs[10];

    if (matchValue) {
      if (matchAttrs[10]) { //no string value
        if (matchValue == "true") { //true
          value = true;
        } else if (matchValue == "false") { //false
          value = false;
        } else if (isFinite(matchValue)) { //number
          value = +matchValue;
        } else { //any other -> null
          value = null;
        }
      } else if (matchAttrs[2] || matchAttrs[3]) { //uu5JSON
        value = this.parseFromUu5JSON(matchValue)
      } else if (matchAttrs[4] || matchAttrs[5]) { //uu5String
        value = this.getChildrenFromUu5String(matchValue)
      } else if (matchAttrs[6] || matchAttrs[7]) { //uu5Data
        value = this.parseFromUu5Data(matchValue)
      } else {
        value = matchValue;
      }
    }

    attrs[name] = value;

    matchAttrs = attrsRegEx.exec(attrsString);
  }

  return attrs;
};

Tools.isUU5String = (uu5String) => {
  return typeof uu5String === 'string' && !!uu5String.match(/^<uu5string\s*\/>/);
};

Tools.getChildrenFromUu5String = function (uu5String, opt) {
  // opt (Object) - tagsRegExp, checkSpaces, checkGrammar, language - defaults from UU5.Bricks.TextCorrector
  opt = opt || {};

  let tagsRegExp = opt.tagsRegExp || Environment.uu5StringTagsRegExp || null;

  // first level
  let reS = /(<\/?)([-\w.]+)((?:\s+\w+(?:\s*=\s*(?:(?:"(?:\\.|[^"])*")|(?:'(?:\\.|[^'])*')|[^>\s]+))?)*)\s*(\/?>)((?:[^<])*)/g;
  let marker = '<uu5string/>';
  uu5String = uu5String.slice(uu5String.indexOf(marker) + marker.length);

  let childStack = [{
    tag: 'helperRoot',
    content: [],
    index: 0
  }];

  let pointer = childStack[0];

  let firstTag = uu5String.indexOf('<');
  if (firstTag > 0) {
    pointer.content.push(uu5String.substr(0, firstTag));
  } else if (firstTag === -1) {
    pointer.content.push(uu5String);
  }

  let matchS = (firstTag === -1) ? null : reS.exec(uu5String);

  while (matchS) {
    let childTag = matchS[2];
    let tagObj;

    if (matchS[1] === '</') {
      //closing tag
      tagObj = childStack.pop();

      if (tagObj.tag !== childTag) {
        //ERROR
        Tools.error("Invalid uu5string", { uu5String: uu5String, tag: tagObj.tag, position: tagObj.index });
        return React.createElement(
          UU5.Bricks.Error,
          null,
          `Invalid uu5string: ${uu5String}. Tag ${tagObj.tag} at position ${tagObj.index} is not closed.`
        );
      }

      if (tagObj.forbidden) {
        tagObj.content = [`Error: Tag <${tagObj.tag}/> is not allowed.`];
        tagObj.tag = "UU5.Bricks.Error";
      }

      //regex for special Html charactes
      let regex = /&#?[a-z0-9]+;/g;
      let matchContent = tagObj.content.toString().match(regex);

      if (matchContent) {
        let replacedContent = tagObj.content.toString().replace(regex, (item) => {
          return Tools.encodeHTML(item, regex, Tools.encodeHTMLmap);
        });
        tagObj.content = tagObj.content.length ? React.Children.toArray(replacedContent) : null;
      } else {
        tagObj.content = tagObj.content.length ? React.Children.toArray(tagObj.content) : null;
      }
      pointer = childStack[childStack.length - 1];
      let cTag = this.findTag(tagObj.tag);
      if (cTag) {
        pointer.content[pointer.content.length - 1] = this.findTag(tagObj.tag, tagObj.attrs, tagObj.content);
      } else {
        pointer.content[pointer.content.length - 1] = React.createElement(Tools.findTag("UU5.Bricks.NotFoundTag"), { tagName: uu5String.substr(tagObj.index, matchS.index - tagObj.index + matchS[0].length) });
      }

    } else {
      tagObj = {
        tag: childTag,
        content: [],
        index: matchS.index
      };

      if (tagsRegExp && !tagsRegExp.test(childTag))
        tagObj.forbidden = true;
      else
        tagObj.attrs = this.buildAttributes(matchS[3]);

      if (matchS[4] === '/>') {
        //self-closing tag
        let cTag = this.findTag(tagObj.tag);
        if (cTag) {
          pointer.content.push(this.findTag(tagObj.tag, tagObj.attrs, null));
        } else {
          pointer.content.push(React.createElement(Tools.findTag("UU5.Bricks.NotFoundTag"), { tagName: uu5String.substr(tagObj.index, matchS.index - tagObj.index + matchS[0].length) }));
        }
      } else {
        //common tag
        pointer.content.push(tagObj);
        childStack.push(tagObj);
        pointer = tagObj;
      }
    }

    //text after tag
    if (matchS[5]) pointer.content.push(matchS[5]);
    matchS = reS.exec(uu5String);
  }

  if (childStack.length > 1) {
    let tagObj = childStack.pop();

    Tools.error("Invalid uu5string", { uu5String: uu5String, tag: tagObj.tag, position: tagObj.index });
    return React.createElement(
      UU5.Bricks.Error,
      null,
      `Invalid uu5string: ${uu5String}. Tag ${tagObj.tag} at position ${tagObj.index} is not closed.`
    );
  }

  return React.Children.toArray(pointer.content)
};

Tools.parseFromUu5JSON = function (uu5Json) {
  let value
  try {
    value = JSON.parse(uu5Json.slice(10));//<uu5json/>
  }
  catch (err) {
    Tools.error(
      'Error uu5JSON parse.', {
        uu5String: uu5String,
        cause: err
      }
    );
    value = null;
  }
  finally {
    return value
  }
};

Tools.parseFromUu5Data = function (uu5data) {
  let data = UU5.Environment.uu5DataMap && UU5.Environment.uu5DataMap[uu5data.slice(10)];
  (typeof data === "undefined") &&
  Tools.warning('There are no component data in UU5.Environment.uu5DataMap for uu5Data:' + uu5data.slice(10) + '!', {
    string: uu5data
  });
  return data;
};

Tools.encodeHTML = (text, reg, encodeHTMLmap) => {
  reg = reg || /&#?[a-z0-9]+;/g;
  encodeHTMLmap = encodeHTMLmap || Tools.encodeHTMLmap;

  return text.replace(reg, (item) => {
    return encodeHTMLmap[item];
  });

};

Tools.encodeHTMLmap = {
  '&amp;': '&',
  '&#38;': '&',
  '&apos;': "'",
  '&#39;': "'",
  '&quot;': '"',
  '&#34;': '"',
  '&lt;': '<',
  '&#060;': '<',
  '&gt;': '>',
  '&#062;': '>',
  '&hellip;': '…',
  '&#133;': '…',
  '&mdash;': '—',
  '&#8212;': '—',
  '&pi;': 'π',
  '&#8719;': 'π',
  '&reg;': '®',
  '&#174;': '®',
  '&#8730;': '√',
  '&radic;': '√',
  '&#8734;': '∞',
  '&infin;': '∞',
  '&#160;': ' ',
  '&nbsp;': ' ',
  '&#8592;': '←',
  '&larr;': '←',
  '&#8594;': '→',
  '&rarr;': '→',
  '&#8595;': '?',
  '&darr;': '?',
  '&#169;': '©',
  '&copy;': '©',
};

Tools.pad = function (n, width, z) {
  //return width times leading z for n ... pad(99,5,'-') -> '---99'
  z = z || '0';
  n = n + '';
  return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
};

Tools.getServerRequest = function (src, parameters, contentType, done, fail) {
  let request = new XMLHttpRequest();
  request.open('GET', src, true);

  contentType && request.setRequestHeader("Content-type", contentType);
  parameters && request.setRequestHeader("Content-length", parameters.length);

  request.onload = () => {
    done(request.response);
  };

  request.onerror = () => {
    if (request.status >= 200 && request.status < 300) {
      typeof done === 'function' && done(request.response);
    } else if (typeof fail === 'function') {
      fail(request);
    }
  };

  request.send(parameters);
};

Tools._merge = function (args, deep) {
  //   var result;
  //   if(args.length){
  //     result = window.Immutable.fromJS(args[0]);
  //
  //     for(var i = 1; i < args.length; i++){
  //       result = deep ? result.mergeDeep(args[i]) : result.merge(args[i]);
  //     }
  //
  //     result = result.toJS();
  //   }
  //   return result;

  var result;
  if (args.length) {
    var data = deep ? [true, {}] : [{}];

    for (var i = 0; i < args.length; i++) {
      data.push(args[i]);
    }

    result = Tools.extend.apply(null, data);
  }
  return result;
};

Tools.mergeDeep = function () {
  return Tools._merge(arguments, true);
};

Tools.merge = function () {
  return Tools._merge(arguments);
};

Tools.mergeEnvironmentUu5DataMap = function (uu5DataMap) {
  UU5.Environment.uu5DataMap = UU5.Common.Tools.merge(UU5.Environment.uu5DataMap || {}, uu5DataMap);
};

Tools.getUrlParam = function (name) {
  var results = new RegExp('[\?&]' + name + '=([^&#]*)').exec(window.location.href);
  return results ? results[1] : null;
};

// used for error context which is sent to server
Tools.getBasicObject = function (object) {
  var result = {};

  if (object['$$typeof']) {
    result = typeof object.type === 'function' ? object.type.tagName : object.type;
  } else if (object['updater']) {
    result = object['getTagName'] ? object.getTagName() : '[React.element]';
  } else {
    for (var key in object) {
      if (key !== '__proto__') {
        var value = object[key];

        if (value && typeof value === 'object') {
          value = this.getBasicObject(value);
        } else if (typeof value === 'function') {
          value = '[function]';
        }

        result[key] = value;
      }
    }
  }
  return result;
};

Tools.getNavigator = function () {
  var navigator = window.navigator;
  return {
    vendor: navigator.vendor,
    maxTouchPoints: navigator.maxTouchPoints,
    hardwareConcurrency: navigator.hardwareConcurrency,
    appCodeName: navigator.appCodeName,
    appName: navigator.appName,
    appVersion: navigator.appVersion,
    platform: navigator.platform,
    product: navigator.product,
    userAgent: navigator.userAgent,
    language: navigator.language,
    languages: navigator.languages,
    onLine: navigator.onLine,
    cookieEnabled: navigator.cookieEnabled,
    doNotTrack: navigator.doNotTrack
  };
};

// Tools.logError = function (data) {
//   $.ajax(
//     {
//       url: Environment.logErrorUrl,
//       type: 'post',
//       cache: false,
//       contentType: 'application/json',
//       data: JSON.stringify(
//         {
//           uri: Environment.logErrorUrl,
//           data: data
//         }
//       )
//     }
//   ).fail(
//     function (failDtoIn) {
//       Tools.error('Cannot send error to server', {failDtoIn: failDtoIn});
//     }
//   );
// };

Tools.getFileName = function (path) {
  return path.replace(/^.*[\\\/]/, '');
};

Tools.getCamelCase = function (string) {
  var camelCase = '';
  if (string) {
    camelCase = string.charAt(0).toUpperCase() + string.slice(1);
    camelCase = camelCase.replace(/(\-[a-z])/g, function ($1) {
      return $1.toUpperCase().replace('-', '');
    });
  }
  return camelCase;
};

// Element
Tools.getDocumentHeight = () => {
  let body = document.body;
  let html = document.documentElement;

  return Math.max(body.scrollHeight, body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight);
};

Tools.getDocumentWidth = () => {
  let body = document.body;
  let html = document.documentElement;

  return Math.max(body.scrollWidth, body.offsetWidth, html.clientWidth, html.scrollWidth, html.offsetWidth);
};

Tools.getWidth = function (element) {
  let paddingLeft = parseInt(window.getComputedStyle(ReactDOM.findDOMNode(element), null).getPropertyValue('padding-left').replace('px', ''));
  let paddingRight = parseInt(window.getComputedStyle(ReactDOM.findDOMNode(element), null).getPropertyValue('padding-right').replace('px', ''));
  return ReactDOM.findDOMNode(element).clientWidth - paddingLeft - paddingRight;
};

Tools.getInnerWidth = function (element) {
  return ReactDOM.findDOMNode(element).clientWidth;
};

Tools.getOuterWidth = function (element, withMargin) {
  let result = ReactDOM.findDOMNode(element).offsetWidth;
  if (withMargin) {
    let marginLeft = parseInt(window.getComputedStyle(ReactDOM.findDOMNode(element), null).getPropertyValue('margin-left').replace('px', ''));
    let marginRight = parseInt(window.getComputedStyle(ReactDOM.findDOMNode(element), null).getPropertyValue('margin-right').replace('px', ''));
    result += marginLeft + marginRight;
  }
  return result;
};

Tools.getHeight = function (element) {
  let paddingTop = parseInt(window.getComputedStyle(ReactDOM.findDOMNode(element), null).getPropertyValue('padding-top').replace('px', ''));
  let paddingBottom = parseInt(window.getComputedStyle(ReactDOM.findDOMNode(element), null).getPropertyValue('padding-bottom').replace('px', ''));
  return ReactDOM.findDOMNode(element).clientHeight - paddingTop - paddingBottom;
};

Tools.getInnerHeight = function (element) {
  return ReactDOM.findDOMNode(element).clientHeight;
};

Tools.getOuterHeight = function (element, withMargin) {
  let result = ReactDOM.findDOMNode(element).offsetHeight;
  if (withMargin) {
    let marginTop = parseInt(window.getComputedStyle(ReactDOM.findDOMNode(element), null).getPropertyValue('margin-top').replace('px', ''));
    let marginBottom = parseInt(window.getComputedStyle(ReactDOM.findDOMNode(element), null).getPropertyValue('margin-bottom').replace('px', ''));
    result += marginTop + marginBottom;
  }
  return result;
};

Tools.getOffsetTop = function (element) {
  let offsetTop = 0;
  do {
    if (!isNaN(element.offsetTop)) {
      offsetTop += element.offsetTop;
    }
  } while (element = element.offsetParent);
  return offsetTop;
};

Tools.getOffsetLeft = function (element) {
  let offsetLeft = 0;
  do {
    if (!isNaN(element.offsetLeft)) {
      offsetLeft += element.offsetLeft;
    }
  } while (element = element.offsetParent);
  return offsetLeft;
};

Tools.getChildTag = function (child) {
  // react child type
  return child.type;
};

Tools.getChildDisplayName = function (child) {
  var tag = Tools.getChildTag(child);
  return typeof tag === 'function' ? tag.displayName : tag;
};

Tools.getChildTagName = function (child) {
  // UU5 tagNames or standard DOM tags ('div', 'span',...)
  var tag = Tools.getChildTag(child);
  return typeof tag === 'function' ? tag.tagName : tag;
};

// Environment
Tools.isMobileOrTablet = function () {
  var check = false;
  (function (a) {
    if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true;
  })(navigator.userAgent || navigator.vendor || window.opera);
  return check;
}();

// Cookies
Tools.setCookie = function (cookieName, cookieValue, expireDays) {
  var d = new Date();
  d.setTime(d.getTime() + expireDays * 24 * 60 * 60 * 1000);
  var expires = 'expires=' + d.toUTCString();
  document.cookie = cookieName + '=' + cookieValue + '; ' + expires;
};

Tools.getCookie = function (cookieName) {
  var name = cookieName + '=';
  var ca = document.cookie.split(';');
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return '';
};

// languagesString = 'cs-CZ,en;q=0.6,sk;q=0.8' => [{language: 'cs', location: 'cs-cz', q: 1.0}, {language: 'sk', q:
// 0.8}, {language: 'en', q: 0.6}] languagesString = 'cs' => [{language: 'cs', q: 1.0}] languagesString =
// 'en;q=0.6,sk;q=0.8' => [{language: 'sk', q: 0.8}, {language: 'en', q: 0.6}]
Tools.sortLanguages = function (languagesString) {
  // languagesString = 'cs-CZ,en;q=0.6,sk;q=0.8' => languagesSplitter = ['cs-CZ', 'en;q=0.6', 'sk;q=0.8']
  var languagesSplitter = languagesString.toLowerCase().split(',');

  var languages = {};
  languagesSplitter.forEach(function (lang) {
    var language = {};

    var langOpt = lang.split(';');
    var langStr = langOpt[0];
    var q = 1; // quality factor
    if (langOpt.length > 1) {
      langStr = langOpt[0];
      q = parseFloat(langOpt[1].split('=')[1]);
    }

    var langStrSplitter = langStr.split('-');
    language.language = langStrSplitter[0];
    langStrSplitter[1] && (language.location = langStr);

    if (languages[lang]) {
      languages[lang].q < q && (languages[lang].q = q);
    } else {
      language.q = q;
      languages[lang] = language;
    }
  });

  // languagesArray = [{language: 'cs', location: 'cs-CZ', q: 1.0}, {language: 'en', q: 0.6}, {language: 'sk', q:
  // 0.8}]
  var languagesArray = Object.keys(languages).map(function (lang) {
    return languages[lang];
  });

  // [{language: 'cs', location: 'cs-CZ', q: 1.0}, {language: 'sk', q: 0.8}, {language: 'en', q: 0.6}]
  return languagesArray.sort(function (lang1, lang2) {
    var result = 0;
    if (lang1.q < lang2.q) {
      result = 1;
    } else if (lang1.q > lang2.q) {
      result = -1;
    }
    return result;
  });
};

Tools.generateUUID = function () {
  var d = new Date().getTime();
  if (window.performance && typeof window.performance.now === 'function') {
    d += performance.now(); //use high-precision timer if available
  }
  return 'xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = (d + Math.random() * 16) % 16 | 0;
    d = Math.floor(d / 16);
    return (c == 'x' ? r : r & 0x3 | 0x8).toString(16);
  });
};

Tools.joinClassNames = (className1, className2) => {
  return [className1, className2].join(' ').replace(/\s\s+/g, ' ').trim();
};

Tools.buildClasses = function (classes, keys) {
  var className = '';
  classes && keys.forEach(function (v) {
    classes[v] && (className += ' ' + classes[v]);
  });
  return className.trim();
};

Tools.isInClasses = function (classes, regExp) {
  var classesArray = classes ? classes.split(' ') : [];
  var result = false;
  while (!result && classesArray.length) {
    classesArray[0].match(regExp) && (result = true);
    classesArray.shift();
  }
  return result;
};

Tools.buildCounterCallback = function (callback, count) {
  /*
   Method wrap (function) callback by newCallBack.
   If newCallBack is used, increase closureCounter
   but call callback just if closureCounter === count.
   You can use this 'tricky' method, when you want to call callback
   just once but you have to send it to several methods.
   See examples!!!
   */
  var newCallback = null;
  if (typeof callback === 'function') {
    var closureCounter = 0;
    newCallback = function () {
      closureCounter++;
      closureCounter === count && callback.apply(null, arguments);
    };
  }
  return newCallback;
};

Tools._replaceParamsInString = function (string, stringParams) {
  var i = 0;
  return string.replace(/%((%)|s|d)/g, function (match) {
    // match is the matched format, e.g. %s, %d
    var val = null;
    if (match[2]) {
      val = match[2];
    } else if (stringParams) {
      val = stringParams[i];
      // A switch statement so that the formatter can be extended. Default is %s
      switch (match) {
        case '%d':
          var parsedVal = parseFloat(val);
          if (isNaN(parsedVal)) {
            // cannot use showWarning because of this method is used in showWarning !!!
            Tools.warning('Value ' + val + ' is not number!', {
              string: string,
              stringParams: stringParams
            });
            val = '%d';
          }
          break;
      }
      i++;
    }
    return val;
  });
};

Tools._setParamsToString = function (string, stringParams) {
  return string.replace(/{(\d+)}/g, function (match, number) {
    return stringParams && typeof stringParams[number] != 'undefined' ? stringParams[number] : match;
  });
};

Tools.formatString = function (string, stringParams) {
  var result;
  stringParams = stringParams && !Array.isArray(stringParams) ? [stringParams] : stringParams;

  if (string.indexOf('%s') > -1 || string.indexOf('%d') > -1) {
    result = Tools._replaceParamsInString(string, stringParams);
  } else {
    result = Tools._setParamsToString(string, stringParams);
  }
  return result;
};

Tools.scrollToTarget = (id, smoothScroll, offset) => {

  //stop scroll on this events: scroll mousedown wheel DOMMouseScroll mousewheel keyup touchmove
  let html = document.documentElement;
  Environment.EventListener.addEvent(html, 'scroll', id, cancel);
  Environment.EventListener.addEvent(html, 'mousedown', id, cancel);
  Environment.EventListener.addEvent(html, 'wheel', id, cancel);
  Environment.EventListener.addEvent(html, 'DOMMouseScroll', id, cancel);
  Environment.EventListener.addEvent(html, 'mousewheel', id, cancel);
  Environment.EventListener.addEvent(html, 'keyup', id, cancel);
  Environment.EventListener.addEvent(html, 'touchmove', id, cancel);

  let element = id ? document.getElementById(id.replace('#', '')) : document.body;
  let y = (Tools.getOffsetTop(element) || 0) + (offset || 0);

  let _update;
  let _from = scroll();
  let _duration = smoothScroll || 1000;
  let _curr = _from; //Tools merge
  let _done = false;
  let _start = Date.now();

  // x, y coordinates
  let _to = { top: y, left: 0 };

  let _ease = (n) => {
    n *= 2;
    if (n < 1) return 0.5 * n * n;
    return -0.5 * (--n * (n - 2) - 1);
  };

  update((o) => {
    window.scrollTo(o.left | 0, o.top | 0);
  });

  function cancel() {
    _done = true;
    Environment.EventListener.removeEvent(html, 'scroll', id);
    Environment.EventListener.removeEvent(html, 'mousedown', id);
    Environment.EventListener.removeEvent(html, 'wheel', id);
    Environment.EventListener.removeEvent(html, 'DOMMouseScroll', id);
    Environment.EventListener.removeEvent(html, 'mousewheel', id);
    Environment.EventListener.removeEvent(html, 'keyup', id);
    Environment.EventListener.removeEvent(html, 'touchmove', id);
    return this;
  }

  function step() {
    if (!_done) {

      // duration
      let duration = _duration;
      let now = Date.now();
      let delta = now - _start;
      let done = delta >= duration;

      // complete
      if (done) {
        _from = _to;
        _update(_to);
        _done = true;
        return this;
      }

      let from = _from;
      let to = _to;
      let curr = _curr;
      let fn = _ease;
      let p = (now - _start) / duration;
      let n = fn(p);

      for (let k in from) {
        curr[k] = from[k] + (to[k] - from[k]) * n;
      }

      _update(curr);
    }
    return this;
  }

  function update(fn) {
    if (0 == arguments.length) return step();
    _update = fn;
    return this;
  }

  function scroll() {
    let y = window.pageYOffset || document.documentElement.scrollTop;
    let x = window.pageXOffset || document.documentElement.scrollLeft;
    return { top: y, left: x };
  }

  function animate() {
    let raf = window.requestAnimationFrame
      || window.webkitRequestAnimationFrame
      || window.mozRequestAnimationFrame
      || fallback;
    raf(animate);
    update();
  }

  function fallback(fn) {
    let prev = new Date().getTime();
    let curr = new Date().getTime();
    let ms = Math.max(0, 16 - (curr - prev));
    let req = setTimeout(fn, ms);
    prev = curr;
    return req;
  }

  animate();

  return this;
};

Tools.error = function (msg, context) {
  // if (Environment.isProduction()) {
  //   console.error('For debugging use development mode.');
  // } else {
  console.error(msg, context);
  // }

  if (Environment.logErrorFunction) {
    let data = {
      message: msg,
      context: Tools.getBasicObject(context),
      navigator: Tools.getNavigator(),
      stackTrace: new Error().stack
    };

    if (typeof Environment.logErrorFunction === 'function') {
      Environment.logErrorFunction(data);
    } else {
      //Tools.logError(data);
      console.error(`Please add to "UU5.Environment.logErrorFunction" your own function as:
      function (data) {
        $.ajax(
          {
            url: '...',
            type: 'post',
            cache: false,
            contentType: 'application/json',
            data: JSON.stringify(
              {
                data: data
              }
            )
          }
        ).fail(
          function (failDtoIn) {
            UU5.Common.Tools.error('Cannot send error to server', {failDtoIn: failDtoIn});
          }
        );
      }`, context);
    }
  }
};

Tools.warning = function (msg, context) {
  // if (!Environment.isProduction()) {
  console.warn(msg, context);
  // }
};

Tools.repeat = (value, count) => {
  let rpt = '';
  let str = value + '';

  for (; ;) {
    if ((count & 1) == 1) {
      rpt += str;
    }
    count >>>= 1;
    if (count == 0) {
      break;
    }
    str += str;
  }

  return rpt;
};

Tools.rjust = (string, length, padding) => {
  string = '' + string;
  padding = padding || ' ';
  let newString = string;

  if (string.length < length) {
    newString = Tools.repeat(padding, length).substr(0, length - string.length) + newString;
  }

  return newString;
};

Tools.ljust = (string, length, padding) => {
  string = '' + string;
  padding = padding || ' ';
  let newString = string;

  if (string.length < length) {
    newString += Tools.repeat(padding, length).substr(0, length - string.length);
  }

  return newString;
};

// TODO: nezaokrouhluje jen desetinná místa -> není to decimalAdjust, ale numberAdjust
Tools.decimalAdjust = (type, value, exp) => {
  // If the exp is undefined or zero...
  if (typeof exp === 'undefined' || +exp === 0) {
    return Math[type](value);
  }
  value = +value;
  exp = +exp;
  // If the value is not a number or the exp is not an integer...
  if (isNaN(value) || !(typeof exp === 'number' && exp % 1 === 0)) {
    return NaN;
  }
  // Shift
  value = value.toString().split('e');
  value = Math[type](+(value[0] + 'e' + (value[1] ? (+value[1] - exp) : -exp)));
  // Shift back
  value = value.toString().split('e');
  return +(value[0] + 'e' + (value[1] ? (+value[1] + exp) : exp));
};

// Decimal round
Tools.round10 = function (value, exp) {
  return Tools.decimalAdjust('round', value, exp);
};
// Decimal floor
Tools.floor10 = function (value, exp) {
  return Tools.decimalAdjust('floor', value, exp);
};
// Decimal ceil
Tools.ceil10 = function (value, exp) {
  return Tools.decimalAdjust('ceil', value, exp);
};

Tools.encodeValue = (value) => {
  let result = value + '';

  if (value && (Array.isArray(value) || typeof value === 'object')) {
    result = JSON.stringify(value);
  }

  return encodeURIComponent(result);
};

Tools.encodeQuery = (params) => {
  let query = '?';

  for (let name in params) {
    query += name + '=' + Tools.encodeValue(params[name]) + '&';
  }

  return query.substr(0, query.length - 1);
};

Tools.isJson = (str) => {
  try {
    return JSON.parse(str);
  } catch (e) {
    return false;
  }
};

Tools.decodeValue = (value) => {
  value = decodeURIComponent(value);
  let result = value;

  if (!isNaN(value)) {
    result = +value;
  } else if (value === 'true') {
    result = true;
  } else if (value === 'false') {
    result = false;
  } else {
    let json = Tools.isJson(value);

    if (json) {
      result = json;
    }
  }

  return result;
};

Tools.decodeQuery = (query) => {
  let params = {};

  query.substr(1, query.length - 1).split('&').forEach(value => {
    let valueSplitter = value.split('=');
    params[valueSplitter[0]] = Tools.decodeValue(valueSplitter[1]);
  });

  return params;
};

Tools.copyToClipboard = (content) => {
  let tempElement = document.createElement('textarea');
  tempElement.innerText = content;
  document.body.appendChild(tempElement);
  tempElement.select();
  document.execCommand('copy');
  tempElement.remove();
};

Tools.getWeekNumber = (date) => {
  let d = new Date(+date);
  d.setHours(0, 0, 0);
  d.setDate(d.getDate() + 4 - (d.getDay() || 7));
  return Math.ceil((((d - new Date(d.getFullYear(), 0, 1)) / 8.64e7) + 1) / 7);
};

Tools.formatDate = (date, format, timeZone) => {
  if (timeZone) {
    let utc = new Date(date.getTime() + date.getTimezoneOffset() * 60000);
    date = new Date(utc.getTime() + timeZone * 60 * 60000);
  }

  let config = {
    'd+': date.getDate(),    //day
    'm+': date.getMonth() + 1, //month
    'y': (date.getFullYear() + '').substr(2, 2), // year end
    'Y': date.getFullYear(), // year full
    'h+': date.getHours() > 12 ? date.getHours() - 12 : (date.getHours() === 0 ? 12 : date.getHours()),   //hour 1 - 12
    'H+': date.getHours(),   //hour
    'M+': date.getMinutes(), //minute
    'S+': date.getSeconds(), //second
    's+': date.getMilliseconds(), //millisecond
    't': date.getHours() > 12 || date.getHours() < 1 ? 'p.m.' : 'a.m.',
    'T': date.getHours() > 12 || date.getHours() < 1 ? 'PM' : 'AM',
    'w+': Tools.getWeekNumber(date),
    'q': Math.floor((date.getMonth() + 3) / 3),  //quarter
    'Z': typeof timeZone === "number" ? timeZone * 60 : -date.getTimezoneOffset()
  };

  for (let k in config) {
    if (new RegExp('(' + k + ')').test(format)) {
      let _formatValue = (chars, value) => {
        let result = value;

        if (chars === 'Z') {
          if (value > 0) {
            result = '+';
          } else {
            result = '-';
            value *= -1;
          }
          result += Tools.rjust(Math.floor(value / 60), 2, '0') + ':' + Tools.rjust(Math.floor(value % 60), 2, '0');
        } else if (chars.length === 2) {
          if (chars === 'ss') {
            result = Tools.rjust(value, 3, '0');
          } else {
            result = Tools.rjust(value, 2, '0');
          }
        }
        return result;
      };

      format = format.replace(RegExp.$1, _formatValue(RegExp.$1, config[k]));
    }
  }
  return format;
};

Tools.extend = function () {
  let src, copyIsArray, copy, name, options, clone,
    target = arguments[0] || {},
    i = 1,
    length = arguments.length,
    deep = false;

  // Handle a deep copy situation
  if (typeof target === "boolean") {
    deep = target;

    // skip the boolean and the target
    target = arguments[i] || {};
    i++;
  }

  // Handle case when target is a string or something (possible in deep copy)
  if (typeof target !== "object" && typeof target !== "function") {
    target = {};
  }

  // extend jQuery itself if only one argument is passed
  if (i === length) {
    target = this;
    i--;
  }

  for (; i < length; i++) {
    // Only deal with non-null/undefined values
    if ((options = arguments[i]) != null) {
      // Extend the base object
      for (name in options) {
        src = target[name];
        copy = options[name];

        // Prevent never-ending loop
        if (target === copy) {
          continue;
        }

        // Recurse if we're merging plain objects or arrays
        if (deep && copy && ( Tools.isPlainObject(copy) || (copyIsArray = Array.isArray(copy)) )) {
          if (copyIsArray) {
            copyIsArray = false;
            clone = src && Array.isArray(src) ? src : [];

          } else {
            clone = src && Tools.isPlainObject(src) ? src : {};
          }

          // Never move original objects, clone them
          target[name] = Tools.extend(deep, clone, copy);

          // Don't bring in undefined values
        } else if (copy !== undefined) {
          target[name] = copy;
        }
      }
    }
  }

  // Return the modified object
  return target;
};

Tools.isPlainObject = (obj) => {
  let result = false;
  if (typeof obj == 'object' && obj !== null) {
    if (typeof Object.getPrototypeOf == 'function') {
      let proto = Object.getPrototypeOf(obj);
      result = proto === Object.prototype || proto === null;
    } else {
      result = Object.prototype.toString.call(obj) === '[object Object]';
    }
  }
  return result;
};

Tools.isSame = (x, y) => {
  if (x === y) {
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    return x !== x && y !== y;
  }
};

Tools.shallowEqual = (objA, objB) => {
  if (Tools.isSame(objA, objB)) {
    return true;
  }

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  let keysA = Object.keys(objA);
  let keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  for (let i = 0; i < keysA.length; i++) {
    if (!Object.prototype.hasOwnProperty.call(objB, keysA[i])) {
      return false;
    }

    if (objA[keysA[i]] && objB[keysA[i]] && typeof objA[keysA[i]] === 'object' && typeof objB[keysA[i]] === 'object') {
      if (!Tools.shallowEqual(objA[keysA[i]], objB[keysA[i]])) {
        return false;
      }
    } else if (keysA[i] !== 'ref_' && !Tools.isSame(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
};

Tools.prettyJson = (json, space) => (JSON.stringify(JSON.parse(json), null, space || 2));

Tools.childToBodyItem = (child) => {
  return { tag: Tools.getChildTagName(child), props: Tools.mergeDeep({}, child.props) };
};

Tools.getElementByComputedStyle = (element, styleProperty, value) => {
  let result;
  let parent = element.parentElement;
  if (parent) {
    let style = window.getComputedStyle(parent);
    if (style.getPropertyValue(styleProperty) === value) {
      result = parent;
    } else {
      result = Tools.getElementByComputedStyle(parent, styleProperty, value);
    }
  }

  return result;
};

Tools.hasProfile = (sourceProfileList, requestedProfile) => {
  return sourceProfileList ? sourceProfileList.indexOf(requestedProfile) > -1 : false
};

Tools.hasProfileOnly = (sourceProfileList, requestedProfile) => {
  return sourceProfileList ? sourceProfileList.indexOf(requestedProfile) > -1 && sourceProfileList.length === 1 : false
};

Tools.hasSomeProfiles = (sourceProfileList, requestedProfileList) => {
  return requestedProfileList ? requestedProfileList.some((v) => {
    return Tools.hasProfile(sourceProfileList, v)
  }) : false
};

Tools.hasEveryProfiles = (sourceProfileList, requestedProfileList) => {
  return requestedProfileList ? requestedProfileList.every((v) => {
    return Tools.hasProfile(sourceProfileList, v)
  }) : false
};

Tools.getScreenSize = () => {
  let result = 'xs';
  let screenWidth = document.body.clientWidth;

  if (Tools.screenSize.xl < screenWidth) {
    result = 'xl';
  } else if (Tools.screenSize.md < screenWidth) {
    result = 'md';
  } else if (Tools.screenSize.sm < screenWidth) {
    result = 'sm';
  }

  return result;
};

export default Tools;



// WEBPACK FOOTER //
// ./common/tools.js